import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=b0bb4c54&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Forbidden.vue?vue&type=style&index=0&id=b0bb4c54&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b0bb4c54",
  null
  ,true
)

export default component.exports